import React, { Component } from 'react';
import { Icon, Button, Segment, Header, Modal } from 'semantic-ui-react';
import ReactTable from 'react-table';
import AddComment from './AddComment';
class Comment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
    }

    open = () => {
        this.setState({
            open: true
        })
    }
    close = () => {
        this.setState({
            open: false
        })
    }

    handleChange = (e, evt) => {
        this.setState({
            [evt.name]: evt.value
        })

    }

    handleSubmit = (comment) => {
        let resolveItem = this.props.data.filter((item) => {
            return item.requestDoc === comment.documentType || ["G", "R"].indexOf(comment.documentType) >= 0;
        });
        if (resolveItem.length > 0) {
            let resolveAccount = Object.assign(resolveItem[0], { documentType: comment.documentType })
            this.props.handleSubmit(resolveAccount, comment.comment, comment.documentType === "G" || this.props.type === "doc" ? false : true);
            this.close();
        }
    }

    render() {
        return (
            <div>
                <Segment.Group raised>
                    <Segment.Group horizontal>
                        <Segment color="grey" inverted>
                            <Header as="h4">
                                <Icon name="history" />
                                <div className="content">
                                    Request History
                       </div>
                            </Header>
                        </Segment>
                        <Segment color="grey" inverted>
                            <div className="ui right floated small buttons">
                                <Button inverted onClick={this.open}>
                                    <Icon name="plus" />
                                    Add New Comment
                            </Button>
                            </div>
                        </Segment>
                    </Segment.Group>
                    <ReactTable minRows={0} filterable defaultPageSize={this.props.reactTable().pageSize} showPagination={false} defaultFilterMethod={this.props._customFilter} className="celled -striped -highlight "
                        data={this.props.history}
                        getNoDataProps={() => {
                            return { style: { maxWidth: 100, display: 'none' } };
                        }}
                        columns={[{
                            Header: 'DateTime',
                            width: 150,
                            accessor: 'cmmDateTime'
                        }, {
                            Header: 'Account / Consumer',
                            width: 150,
                            accessor: 'cmmAccountId',
                        },/* {
                            Header: 'Doc',
                            maxWidth: 130,
                            accessor: 'cmmType',
                         }, {
                             Header: 'Action',
                             maxWidth: 130,
                             accessor: 'cmmUser',
                         },*/ {
                            Header: 'Comments',
                            accessor: 'cmmComment'
                        }]}
                    />
                </Segment.Group>
                <Modal size="small" open={this.state.open} onClose={this.close} style={{ background: "none" }}>
                    <AddComment docList={["G"]} closeComment={this.close} {...this.props} handleSubmit={this.handleSubmit} />
                </Modal>
            </div>
        );
    }
}
export default Comment;


// WEBPACK FOOTER //
// ./src/app/ui/alerts/Comment.js